// Request util for api call
import request from '~/utils/request';

// Actions
import { SET_API_KEYS_DATA, SET_API_KEYS_LOADER } from './action-types';

const fetchApiKeys = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_API_KEYS_LOADER, payload: true });
    const apiKeys = await request.get('api-keys', payload);
    dispatch({ type: SET_API_KEYS_DATA, payload: apiKeys.data.data });
    return apiKeys;
  } catch (error) {
    return error.response;
  } finally {
    dispatch({ type: SET_API_KEYS_LOADER, payload: false });
  }
};

const createApiKey = (payload) => async () => {
  try {
    const apiKey = await request.post('api-keys', payload);
    return apiKey;
  } catch (error) {
    return error.response;
  }
};

const deleteApiKey = (payload) => async () => {
  try {
    const deleteKey = await request.delete(`api-keys/${payload}`);
    return deleteKey;
  } catch (error) {
    return error.response;
  }
};

const rotateApiKey = (payload) => async () => {
  try {
    const rotateKeys = await request.patch(`api-keys/rotate-key/${payload.selectedApi}`, payload);
    return rotateKeys;
  } catch (error) {
    return error.response;
  }
};

const updateApiKey = (payload) => async () => {
  try {
    const updateKeys = await request.patch(`api-keys/${payload.id}`, payload);
    return updateKeys;
  } catch (error) {
    return error.response;
  }
};

export { fetchApiKeys, createApiKey, deleteApiKey, rotateApiKey, updateApiKey };
